import { useQuery } from "@tanstack/react-query";
import { fetchDashboardStats } from "@/api/dashboard";

export function useDashboardStats() {
  return useQuery({
    queryKey: ["dashboard", "stats"],
    queryFn: fetchDashboardStats,
    // Live figures — refetch on every navigation into the dashboard, not just after staleTime.
    refetchOnMount: "always",
  });
}
